import { Spinner } from "@chakra-ui/react";

export const ComplianceGridLoading = () => (
	<div className="flex items-center justify-center py-16">
		<Spinner data-testid="compliance-grid-spinner" />
	</div>
);
